import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  text-align: center;
  align-items: center; 

  @media (max-width: 1024px) {
    gap: 20px;
  }
`;

export const CarouselButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px 20px 20px;
  width: 100%;
  box-sizing: border-box;
  flex-direction: column;

  @media (max-width: 1024px) {
    gap: 10px;
    padding: 0 10px 16px 10px;
  }
`;

export const CarouselImage = styled.img`
  width: 694px;
  max-width: 100%;
  height: 335px;
  object-fit: cover;
  border-radius: 12px; 
`;

export const Typography = styled.div`
  font-family: 'IBM Plex Sans';
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  width: ${({ isNarrow }) => (isNarrow ? '452px' : '446px')}; 
  height: ${({ isNarrow }) => (isNarrow ? '52px' : '42px')};
  background-color: rgba(255, 255, 255, 0.8); 
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  word-wrap: break-word;   
  overflow-wrap: break-word;
  gap: 0.3rem;

  @media (max-width: 1024px) {
    width: 440px;
  }

`;

export const CarouselSubtext = styled.p`
  font-family: 'IBM Plex Sans';
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0%;
  text-align: center;
  color: #56515B;
  height: 40px;
  width:472px;

  @media (max-width: 1024px) {
    font-size: 13px;
    line-height: 16px;
  }
`;
